import Pro1 from '../assets/pro1.jpg';
import Pro2 from '../assets/pro2.jpg';
import Pro3 from '../assets/pro3.PNG';
import Pro4 from '../assets/pro4.PNG';

const ProjectCardData = [
    {
        imgsrc: Pro1,
        title: "Face Detection Using Clarifai API",
        text: "In in project user crete account and provide url of image. Using Clarifai api site will detect face in image. It also uses react, Express, MongoDB etc",
        view: "https://github.com/karthik6325/Face-Detection-BackEnd",
    },
    {
        imgsrc: Pro2,
        title: "Portfolio Site",
        text: "It is my portfolio site. It is built using react,javascript and css",
        view: "https://github.com/karthik6325/portfolio",
    },
    {
        imgsrc: Pro3,
        title: "Movies_App",
        text: "It is a React application for movie enthusiasts, featuring updated lists of popular, top-rated, and upcoming movies. It uses the movie database (TMDB) Api to fetch the required data.",
        view: "https://github.com/karthik6325/Movies_app",
    },
    {
        imgsrc: Pro4,
        title: "Find-Donor",
        text: "I developed a MERN web application that connects blood donors with those in need. Any user can create an account, after creation of account users can register as donors or seekers, storing theirinformation in a database. When seekers search for donors based on city and blood type, the application instantly displays a list of matching donors.",
        view: "https://github.com/karthik6325/FindDonor",
    },
];

export default ProjectCardData;